/*******************************************************************************
 * @ngdoc    object
 * @module   csm.books.WriteChecks
 * @name     csm.books.WriteChecks.type:DGExpenseItem
 * @constructor
 * @param {object=} item Source object to populate properties.
 * @description
 * Datagrid expense item class. This will manage a child ExpenseItem object. The
 * provided item can be a ExpenseItem or a Purchase Order or Invoice item.
 *
 * TODO: This uses the Backstore pattern with accessors to `mItem`, which is more
 * TODO: of a challenge to inherit. Needs to be refactored into the Direct-Access
 * TODO: pattern such as in `MakeDeposit`.
 *******************************************************************************/
/* @ngInject */ export function dataGridExpenseItemFactory(Tools) {
  var DGExpenseItem = function (item) {
    this.mItem = item || {};
    this.mAccount = !item
      ? null
      : {
          accountName: item.accountName,
          accountNumber: item.accountNumber,
          accountID: item.accountID
        };
    this.mClass = !item ? null : { name: item.className, id: item.classID };
  };

  DGExpenseItem.prototype = {
    mItem: null,
    mAccount: null,
    mClass: null,

    /**
     * @ngdoc       property
     * @name        getSource
     * @propertyOf  DGExpenseItem.type:DGExpenseItem
     * @description Returns actual backstore `mItem`.
     */
    getSource: function () {
      return this.mItem;
    },

    /**
     * @ngdoc       property
     * @name        forDocument
     * @propertyOf  DGExpenseItem.type:DGExpenseItem
     * @description `true` if the item cannot be edited.
     */
    forDocument: function () {
      return !!this.mItem.referenceItemID;
    }
  };

  /*----------------------*/
  /* Backstore accessors. */
  /*----------------------*/
  Object.defineProperties(DGExpenseItem.prototype, {
    account: {
      get: function () {
        return this.mAccount;
      },
      set: function (v) {
        this.mItem.accountID = (this.mAccount = v) ? v.accountID : 0;
      }
    },

    accountName: {
      set: function () {}, // reject nonmatching text values from the typeahead
      get: function () {
        return this.mAccount
          ? this.mItem.name || this.mAccount.accountName
          : '';
      }
    },

    accountNumber: {
      set: function () {}, // reject nonmatching text values from the typeahead
      get: function () {
        return this.mAccount
          ? this.mItem.number || this.mAccount.accountNumber
          : '';
      }
    },

    amount: {
      get: function () {
        return this.mItem.amount;
      },
      set: function (v) {
        this.mItem.amount = isNaN(v) ? v : Tools.roundToPrecision(v, 2);
      }
    },

    class: {
      get: function () {
        return this.mClass;
      },
      set: function (v) {
        this.mItem.classID = (this.mClass = v) ? v.id : 0;
      }
    },

    className: {
      set: function () {}, // reject nonmatching text values from the typeahead
      get: function () {
        return this.mClass ? this.mClass.class || this.mClass.name : '';
      }
    },

    memo: {
      get: function () {
        return this.mItem.memo || '';
      },
      set: function (v) {
        this.mItem.memo = v;
      }
    }
  });

  return DGExpenseItem;
};
